import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import {FilterFlyoutBoolean} from '../../FilterFlyout/FilterFlyoutBoolean/FilterFlyoutBoolean';

interface Props {
  favoriteBrandsActive: boolean;
  onFavoriteBrandsToggle: () => void;
  className?: string;
  testId?: string;
}

export const FilterByFavoriteBrands: FC<Props> = ({
  favoriteBrandsActive,
  onFavoriteBrandsToggle,
  className,
  testId,
}) => {
  const {t} = useTranslation();

  return (
    <FilterFlyoutBoolean
      className={className}
      active={Boolean(favoriteBrandsActive)}
      data-testid={testId}
      label={t('Filter by favourite brands')}
      onToggle={onFavoriteBrandsToggle}
    />
  );
};
